<template>
    <ClientLayout>
        <CardPage :section="0" :page="0">
            <p class="headline text-xs-center">Resources</p>
            <div class="mb-3">
                <div class="font-weight-bold">Trans Lifeline</div>
                <div>Peer support hotline run by and for trans people. They’re available 9am-3am Central Time</div>
                <div><a href="tel:+18775658860">877-565-8860</a></div>
            </div>
            <div class="mb-3">
                <div class="font-weight-bold">Crisis Text Line</div>
                <div>Free, 24/7 support for people in crisis</div>
                <div><a href="https://www.crisistextline.org/" target="_blank">www.crisistextline.org</a></div>
                <div>Text HOME to <a href="sms:741741">741741</a> from anywhere in the USA to text with a trained Crisis Counselor.</div>
            </div>
            <div class="mb-3">
                <div class="font-weight-bold">The Trevor Project</div>
                <div>Crisis intervention and mental health services for those ages 13-24</div>
                <div><a href="https://www.thetrevorproject.org" target="_blank">www.thetrevorproject.org</a></div>
                <div>Crisis hotline: <a href="tel:+18664887386">866-488-7386</a> (for those ages 13-24)</div>
            </div>
            <div class="mb-3">
                <div class="font-weight-bold">National Sexual Assault Hotline</div>
                <div>24/7 hotline, staffed by trained individuals, for those experiencing sexual assault or violence</div>
                <div><a href="https://www.rainn.org/" target="_blank">www.rainn.org</a></div>
                <div><a href="https://www.rainn.org/es" target="_blank">www.rainn.org/es</a></div>
                <div>Crisis hotline: <a href="tel:+18006564673">800-656-HOPE (4673)</a></div>
            </div>
            <div class="mb-3">
                <div class="font-weight-bold">The National Domestic Violence Hotline</div>
                <div>24/7 confidential crisis line for those experiencing domestic violence</div>
                <div><a href="https://www.thehotline.org/" target="_blank">www.thehotline.org</a></div>
                <div><a href="tel:+18007997233">800-799-SAFE (7233)</a></div>
            </div>
            <div class="mb-3">
                <div class="font-weight-bold">Out2Enroll</div>
                <div>Resources to help transgender people select and enroll in insurance</div>
                <div><a href="http://out2enroll.org" target="_blank">out2enroll.org</a></div>
            </div>
            <div class="mb-3">
                <div class="font-weight-bold">OutCare</div>
                <div>The OutList allows you to search for LGBTQ+ competent doctors and therapists in your area.</div>
                <div><a href="https://www.outcarehealth.org" target="_blank">www.outcarehealth.org</a></div>
            </div>
            <div class="mb-3">
                <div class="font-weight-bold">Human Rights Campaign’s LGBTQ-friendly hospitals and medical centers</div>
                <div>
                    Use this tool to find healthcare facilities near you that promote equitable and inclusive care for LGBTQ+ patients and their families.
                </div>
                <div><a href="https://www.hrc.org/resources/healthcare-facilities" target="_blank">www.hrc.org/resources/healthcare-facilities</a></div>
            </div>
            <div class="mb-3">
                <div class="font-weight-bold">NASEN.org</div>
                <div>A network of syringe exchange programs and other harm reduction services in North America.</div>
                <div><a href="https://nasen.org/" target="_blank">nasen.org</a></div>
            </div>
            <div class="mb-3">
                <div class="font-weight-bold">PleasePrEPMe</div>
                <div>Searchable and location-responsive PrEP and PEP provider directory, in English and Spanish</div>
                <div><a href="https://www.pleaseprepme.org/" target="_blank">www.pleaseprepme.org</a></div>
            </div>
            <div class="mb-3">
                <div class="font-weight-bold">GetTested</div>
                <div>Searchable and location specific HIV, STD and Hepatitis Testing</div>
                <div><a href="https://gettested.cdc.gov/" target="_blank">gettested.cdc.gov</a></div>
            </div>
            <div class="mb-3">
                <div class="font-weight-bold">HIVinfo</div>
                <div>Searchable and location specific HIV treatment services</div>
                <div>
                    <a href="https://hivinfo.nih.gov/understanding-hiv/fact-sheets/how-find-hiv-treatment-services" target="_blank"
                        >hivinfo.nih.gov/understanding-hiv/fact-sheets/how-find-hiv-treatment-services</a
                    >
                </div>
            </div>
            <div class="mb-3">
                <div class="font-weight-bold">Jim Collins Foundation</div>
                <div>Financial support for transition-related expenses for people without insurance or who have been excluded by insurance</div>
                <div><a href="https://jimcollinsfoundation.org/" target="_blank">jimcollinsfoundation.org</a></div>
            </div>
            <div class="mb-3">
                <div class="font-weight-bold">Point of Pride Annual Transgender Surgery Fund</div>
                <div>Provides direct financial assistance to trans folks who cannot afford their gender-affirming surgery</div>
                <div>
                    <a href="https://pointofpride.org/annual-transgender-surgery-fund/" target="_blank">pointofpride.org/annual-transgender-surgery-fund</a>
                </div>
            </div>
            <div class="mb-3">
                <div class="font-weight-bold">ACLU (American Civil Liberties Union)</div>
                <div>National civil rights organization with offices across the United States</div>
                <div>
                    <a href="https://www.aclu.org/about/affiliates?redirect=affiliates" target="_blank">www.aclu.org/about/affiliates?redirect=affiliates</a>
                </div>
            </div>
            <div class="mb-3">
                <div class="font-weight-bold">Trans Lifeline’s ID Change Library</div>
                <div>
                    A community supported database of all the local and national information surrounding ID changes including Tribal IDs, immigration documents,
                    military documents, and name changes for people who are justice involved.
                </div>
                <div><a href="https://translifeline.org/resource/id-change-library/" target="_blank">translifeline.org/resource/id-change-library</a></div>
            </div>
            <div class="mb-3">
                <div class="font-weight-bold">Immigration Equality</div>
                <div>The nation’s leading LGBTQ+ immigrant’s rights organization</div>
                <div><a href="https://immigrationequality.org/" target="_blank">immigrationequality.org</a></div>
            </div>
            <div class="mb-3">
                <div class="font-weight-bold">Feeding America</div>
                <div>National Database of Food Banks</div>
                <div><a href="https://www.feedingamerica.org/" target="_blank">www.feedingamerica.org</a></div>
                <div><a href="tel:+18007712303">800-771-2303</a></div>
            </div>
            <div class="mb-3">
                <div class="font-weight-bold">Shelterlistings.org</div>
                <div>National database of homeless shelters</div>
                <div><a href="https://www.shelterlistings.org/" target="_blank">www.shelterlistings.org</a></div>
            </div>
            <div class="mb-3">
                <div class="font-weight-bold">CenterLink</div>
                <div>A directory of LGBT Community Centers</div>
                <div><a href="https://www.lgbtcenters.org/LgbtCenters" target="_blank">www.lgbtcenters.org/LgbtCenters</a></div>
            </div>
            <div class="mb-3">
                <div class="font-weight-bold">Campus Pride</div>
                <div>A national student-led organization that offers the Campus Pride Index, a list of LGBTQ+ friendly colleges and universities.</div>
                <div><a href="https://www.campuspride.org/" target="_blank">www.campuspride.org</a></div>
            </div>
            <template v-slot:actions>
                <v-spacer></v-spacer>
            </template>
        </CardPage>
    </ClientLayout>
</template>

<script>
export default {
    name: 'Resources'
};
</script>
